<template>
  <div class='hf_con'>
    <div class='block1 text_center'>
      <h3>{{ $t('reading.highfiveClass.title') }}</h3>
      <div class='info'>{{ $t('reading.highfiveClass.desc') }}</div>
      <img src='@/assets/icons/ic_logo_highfive@2x.png' width='120' height='120' alt=''>
      <div class='fz_0' style='margin-top:20px'>
        <div class='load dis_ib ver_m' @click='clickDownLoad'>
          {{ device == 'mobile' ? $t('reading.highfiveClass.download.buttonMobile') : $t('reading.highfiveClass.download.button') }}
        </div>
        <div class='ewm fz_0 dis_ib ver_m' @click='clickDownLoad'>
          <img src='@/assets/icons/ic_qr@2x.png' width='32' height='32' alt='' class='dis_ib ver_m'>
          <span class='dis_ib ver_m'>{{ $t('reading.highfiveClass.download.qrcode') }}</span>
        </div>
      </div>
    </div>
    <div class='block2 text_center'>
      <img class='img1' src='@/assets/icons/Group@2x.png' width='848' height='651' alt=''>
      <div class='info fz_0 pos_r w_1200'>
        <dl class='dis_ib ver_m'>
          <dt>{{ $t('reading.highfiveClass.introTitle') }}</dt>
          <dd>{{ $t('reading.highfiveClass.introDesc') }}</dd>
        </dl>
        <div class='img-wrap'>
          <img src='@/assets/icons/ill_graphics@2x.png' alt='' width='728' height='519' class='pos_a img2'>
        </div>
      </div>
    </div>
    <!-- 二维码 -->
    <app-q-r-code :show='showDialog' @close='closeDownLoadDialog'></app-q-r-code>
  </div>
</template>

<script>
import { setTitle, mediaDevice } from 'utils'
import AppQRCode from '@/components/AppQRCode'

export default {
  name: 'HighFive',
  components: {
    AppQRCode,
  },
  data () {
    return {
      showDialog: false,
      device: '',
    }
  },
  methods: {
    init () {
      this.device = mediaDevice()
    },
    clickDownLoad () {
      setTimeout(() => {
        document.body.className = 'fixed'
      }, 100)
      this.showDialog = true
    },
    closeDownLoadDialog () {
      document.body.className = ''
      this.showDialog = false
    },
  },
  mounted () {
    setTitle(`${this.$t('home.logo')} - HighFive`)
    this.init()
  },
}
</script>
